import DefinitionTooltip from './DefinitionTooltip';
import { PlaceholderText } from './Placeholders';
import kebabCase from 'lodash/kebabCase';
import styled from 'styled-components';
import { tooltips } from '@/copy';

function TableHeading({
    title,
    subtitle,
    count,
    tooltipKey,
    tooltipExample,
    tools,
}) {
    // No key means the caller wants no tooltip. A key that isn't in the copy
    // module still throws -- that is a typo, not a configuration.
    const { body, ...tooltipProps } = tooltipKey ? tooltips[tooltipKey] : {};
    const example = tooltips[tooltipExample];
    const hasCount = count !== undefined;
    const dataComponent = title ? kebabCase(title) : '';
    const dataComponentTitle = dataComponent ? `${dataComponent}-title` : '';
    const dataComponentCount = dataComponent ? `${dataComponent}-count` : '';

    return (
        <CatFiveTableHeading>
            <div className="text-muted-foreground font-medium text-base leading-5">
                <CatFiveSectionHeading>
                    <span data-component={dataComponentTitle}>{title}</span>
                    {hasCount && (
                        <Count data-component={dataComponentCount}>
                            <span>
                                {count || count === 0 ? (
                                    count
                                ) : (
                                    <PlaceholderText width="2rem" />
                                )}
                            </span>{' '}
                            total
                        </Count>
                    )}
                    {tooltipKey && (
                        <DefinitionTooltip
                            body={
                                <>
                                    {body} {example}
                                </>
                            }
                            mixpanelMeta={{ contentKey: tooltipKey }}
                            openOnClick={true}
                            {...tooltipProps}
                        />
                    )}
                </CatFiveSectionHeading>
                <CatFiveSectionSubHeading>{subtitle}</CatFiveSectionSubHeading>
            </div>
            {tools && <Tools>{tools}</Tools>}
        </CatFiveTableHeading>
    );
}

const CatFiveTableHeading = styled.div`
    padding: ${({ theme }) => `${theme.space_8}px ${theme.space_9}px`};
    border-bottom: 1px solid ${({ theme }) => theme.gray_5};
    display: grid;
    grid-column-gap: 10px;
    grid-template-columns: minmax(40%, 1fr) auto;
    grid-template-areas: 'heading tools';
`;

const Count = styled.span`
    font-weight: ${({ theme }) => theme.fontMedium};
    color: ${({ theme }) => theme.gray_3};
    margin: 0px ${({ theme }) => theme.space_4}px;
`;

const CatFiveSectionSubHeading = styled.div`
    line-height: 1.7em;
`;

const CatFiveSectionHeading = styled.div`
    font-family: ${({ theme }) => theme.style_primary};
    font-weight: ${({ theme }) => theme.fontExtrabold};
    color: ${({ theme }) => theme.gray_2};
`;

const Tools = styled.span`
    grid-area: tools;
    display: flex;
    gap: 10px 6px;
    flex-wrap: wrap;
    justify-content: flex-end;
    align-items: center;
`;

export default TableHeading;
